import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { FormEditButtons, WarningModal } from '~/components';

import { restoreOriginalTokenFromTemporary } from '../../../../../components/persist-token/persist-token.utils';

const deepEqual = require('deep-equal');

export class EditButtonsWrapper extends PureComponent {
  state = {
    isOpen: false,
  };

  componentDidMount() {
    const { setHeadlineBackButtonConfig } = this.props;
    if (setHeadlineBackButtonConfig) {
      setHeadlineBackButtonConfig({
        goBack: () => this.cancelEditHandler(),
      });
    }
  }

  cancelEditHandler = () => {
    const {
      state,
      journeyState,
      temporaryDraftAppointment,
      temporaryJourneyState,
      formValues,
      initialFormValues,
      history,
      location,
    } = this.props;
    const isTemporaryStateNotChanged = deepEqual(state, temporaryDraftAppointment);
    const isTemporaryJourneyStateNotChanged = journeyState
      ? deepEqual(journeyState, temporaryJourneyState)
      : true;
    const isFormValuesNotChanged = formValues ? deepEqual(formValues, initialFormValues) : true;

    if (isTemporaryStateNotChanged && isTemporaryJourneyStateNotChanged && isFormValuesNotChanged) {
      this.exitEditMode();
    } else {
      this.setState({ isOpen: true });
      history.pushWithToken({
        search: location.search,
        state: {
          ...(location.state || {}),
          warningModal: {
            isOpen: true,
          },
        },
      });
    }
  };

  backToEditHandler = () => {
    const { history } = this.props;
    history.goBack();
  };

  exitEditMode = () => {
    const {
      history,
      bookingId,
      setEditMode,
      saveTemporaryState,
      onCancelHandler,
      saveTemporaryJourneyState,

      dispatchClearMessages,
    } = this.props;

    if (dispatchClearMessages) {
      dispatchClearMessages();
    }
    setEditMode(false);

    restoreOriginalTokenFromTemporary();

    if (saveTemporaryState) {
      saveTemporaryState({});
    }
    if (saveTemporaryJourneyState) {
      saveTemporaryJourneyState({});
    }
    if (onCancelHandler) {
      onCancelHandler();
    }
    history.pushWithToken(`/${bookingId || 'review'}`);
  };

  previousButtonHandler = () => {
    const { history, prevPath } = this.props;
    history.pushWithToken(prevPath);
  };

  restoreHandler = () => {
    const {
      temporaryDraftAppointment,
      restoreAppointmentDraft,
      restoreJourneyState,
      temporaryJourneyState,
    } = this.props;
    if (restoreAppointmentDraft) {
      restoreAppointmentDraft(temporaryDraftAppointment);
    }
    if (restoreJourneyState) {
      restoreJourneyState(temporaryJourneyState);
    }
    this.exitEditMode();
  };

  render() {
    const {
      saveButtonText,
      displayButtons,
      saveHandler,
      saveButtonExtraProps,
      hideSaveButton,
      showWarningModal,
      hideGoBackButton,
    } = this.props;
    const { isOpen } = this.state;
    return (
      <Fragment>
        {displayButtons ? (
          <FormEditButtons
            cancelHandler={this.cancelEditHandler}
            previousButtonHandler={this.previousButtonHandler}
            saveEditingHandler={saveHandler}
            saveButtonText={saveButtonText}
            saveButtonExtraProps={saveButtonExtraProps}
            hideSaveButton={hideSaveButton}
            hideGoBackButton={hideGoBackButton}
          />
        ) : null}
        {showWarningModal && isOpen ? (
          <WarningModal
            backToEdit={this.backToEditHandler}
            restoreAppointmentDraft={this.restoreHandler}
          />
        ) : null}
      </Fragment>
    );
  }
}

EditButtonsWrapper.propTypes = {
  displayButtons: PropTypes.bool,
  saveButtonText: PropTypes.string,
  prevPath: PropTypes.string,
  temporaryDraftAppointment: PropTypes.shape({}).isRequired,
  temporaryJourneyState: PropTypes.shape({}),
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  state: PropTypes.shape({}).isRequired,
  bookingId: PropTypes.string,
  saveButtonExtraProps: PropTypes.shape({}),
  hideSaveButton: PropTypes.bool,
  hideGoBackButton: PropTypes.bool,
  showWarningModal: PropTypes.bool.isRequired,
  journeyState: PropTypes.shape({}),
  formValues: PropTypes.shape({}),
  initialFormValues: PropTypes.shape({}),

  setEditMode: PropTypes.func.isRequired,
  dispatchClearMessages: PropTypes.func,
  saveHandler: PropTypes.func,
  restoreAppointmentDraft: PropTypes.func,
  restoreJourneyState: PropTypes.func,
  saveTemporaryState: PropTypes.func,
  saveTemporaryJourneyState: PropTypes.func,
  onCancelHandler: PropTypes.func,
  setHeadlineBackButtonConfig: PropTypes.func,
};

EditButtonsWrapper.defaultProps = {
  displayButtons: true,
  hideSaveButton: false,
  hideGoBackButton: false,
  saveButtonText: 'Next',
  prevPath: 'review',
  saveButtonExtraProps: undefined,
  restoreAppointmentDraft: undefined,
  restoreJourneyState: undefined,
  saveTemporaryState: undefined,
  saveTemporaryJourneyState: undefined,
  saveHandler: undefined,
  bookingId: undefined,
  onCancelHandler: undefined,
  journeyState: undefined,
  temporaryJourneyState: undefined,
  initialFormValues: undefined,
  formValues: undefined,
  setHeadlineBackButtonConfig: undefined,
  dispatchClearMessages: undefined,
};
